import { createFileRoute } from '@tanstack/react-router'
import { PacketBearerPage } from '../features/portal/packet-link'

/** No token: the fresh-link request page. Conduit's forwarder lands here without its old bearer. */
export const Route = createFileRoute('/w/')({
  component: function PacketIndexRoute() {
    return <PacketBearerPage token={null} />
  },
})
